import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import { Field } from "react-final-form";
import MetaError from "../MetaError";
import { styles } from "./_base.styles";
import { DateTimeInput } from "../../inputs";
import moment from "moment";

function DateTimeField({ classes, className, id, label, disabled, required, placeholder, minDate, maxDate }) {
  const onChangeHandler = (v, input) => {
    input.onChange && input.onChange(moment.isMoment(v) ? v.format("YYYY-MM-DD HH:mm:ss") : undefined);
  };

  return (
    <div className={classes.root}>
      <Field name={id}>
        {({ input, meta }) => (
          <>
            <DateTimeInput
              className={classes.input + (className ? " " + className : "")}
              id={id}
              label={label}
              value={input.value}
              onChange={(value) => onChangeHandler(value, input)}
              disabled={disabled}
              required={required}
              error={Boolean(meta.error && meta.touched)}
              placeholder={placeholder}
              minDate={minDate}
              maxDate={maxDate}
            />
            <div className={"FormFieldError " + classes.error}>
              <MetaError meta={meta} />
            </div>
          </>
        )}
      </Field>
    </div>
  );
}

export default withStyles(styles)(DateTimeField);
